import React from "react";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner-border loader-div" role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export default Loader;
